export default __webpack_public_path__ + "static/media/wanda.9cab6f88.png";